/**
 * Módulo de analítica y exportaciones (#44). Contrato en `routes/module.ts`.
 *
 * `viewer` alcanza para ver tendencias, regiones y la lista de exportaciones:
 * todo son agregados. Crear una exportación exige `analyst` y descargarla
 * queda en `audit_log`; las dos cosas las controla la API, y acá sólo se
 * esconde el formulario de creación a quien no puede usarlo.
 */
import type { ModuleRoutes } from '../module';
import { AnalyticsPage } from './AnalyticsPage';
import { ExportsPage } from './ExportsPage';

export const moduleRoutes: ModuleRoutes = {
  moduleId: 'analytics',
  minimumRole: 'viewer',
  routes: [
    { path: '', element: <AnalyticsPage /> },
    { path: 'exports', element: <ExportsPage /> },
  ],
};
